// popups.js
import { Popup } from "react-leaflet";
import { SERVICE_HOUSE_URL } from "../../Optics/OpticApiConfig";

export const getHousePopup = (house, iconUrl) => {
  const popupContent = (
    <div className="custom-box-telecom-auto-topo">
      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
        <a
          href={`${SERVICE_HOUSE_URL}?Id=${house.hid}`}
          target="_blank"
          style={{ fontWeight: 'bold', color: "black" }}
        >
          {house.street}, дом. {house.numberHouse}
        </a>
      </span>
      <br />
      <hr className='horizontalLineFilter' />
      <label style={{ color: '#000000ff', fontWeight: 'bold', fontSize: '14px' }}>
        ID: <span style={{ color: '#000000ff', fontWeight: 'normal' }}>{house.hid}</span>
      </label><br />
      {/* <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: '14px' }}>
        Подъездов:<span style={{ color: '#6d0404', fontWeight: 'normal' }}> {house.entrance}</span>
      </span><br />
      <label style={{ color: '#000000ff', fontWeight: 'bold', fontSize: '14px' }}>
        ПАБ: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.apartments}</span>
      </label><br /> */}
      <label style={{ color: '#000000ff', fontWeight: 'bold', fontSize: '14px' }}>
        Статус: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.statusName}</span>
      </label><br />
      <hr className='horizontalLineFilter' style={{ height: "1px" }} />
    </div>
  );

  const wrapper = (label, bg) => (
  <Popup className='custom-popup-auto-topo'>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

    {/* 🔹 Первая строка: иконка + label */}
  

      {label && (
        <div className="popup-label-node" style={{ background: bg}}>
        <img
            src={iconUrl}
            width="30"
            height="30"
            alt="House"
        />
          {label}
        </div>
      )}
    </div>
     <hr style={{color: "#ffb560ff", marginTop: "5px", marginBottom: "10px" }}/>

    {/* 🔹 Вторая строка: popupContent снизу */}
    {popupContent}


</Popup>
  );

  switch (house.rank) {
    case 3:
      return wrapper("3К", "linear-gradient(90deg, rgb(218, 255, 211), rgb(161, 250, 176))");
    case 1:
      return wrapper("100К", "linear-gradient(90deg, #fdb0b0ff, #f86363ff)");
    case 2:
      return wrapper("30К", "linear-gradient(90deg, #f8d79aff, #ffbc40ff ");
    default:
      return wrapper(null, null);
  }
};
